module.exports = __webpack_public_path__ + "static/media/create.f85f8984.svg";